<template>
    <page>
        <module enable-flex>
            <view-list ref="view" :work-type="18">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="背贴码">
                            <m-code-batch-input name="produce_unique_codes" field-name="背贴码"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="IMEI">
                            <m-code-batch-input name="produce_imeis" field-name="IMEI"></m-code-batch-input>
                        </m-search-item>
                        <m-search-item label="商户">
                            <c-select name="merchant_id" async @search="searchMerchant"></c-select>
                        </m-search-item>
                        <m-search-item label="商户名称">
                            <c-input name="merchant_name" placeholder="支持模糊查询"></c-input>
                        </m-search-item>
                        <m-search-item label="商品名称">
                            <c-input name="product_name" placeholder="支持模糊查询"></c-input>
                        </m-search-item>
                        <m-search-item label="推送渠道">
                            <c-select name="channel_id" async @search="searchChannel"></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间" colspan="2">
                            <c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <c-table-column type="button" label="操作" width="80" fixed="right">
                    <template #default="{data}">
                        <c-table-button icon="tf-detail" @click="$refs.detail.open(data)">详情</c-table-button>
                    </template>
                </c-table-column>

                <template #saas_info="{data}">
                    <div class="m-saas-info">
                        <p>{{data.saas_id || '-'}}</p>
                        <p class="m-saas-info-name">{{data.saas_name || '-'}}</p>
                    </div>
                </template>

                <template #product_info="{data}">
                    <m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
                </template>

                <template #produce_unique_code="{data}">
                    {{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <template #produce_imei="{data}">
                    {{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
                </template>

                <template #push_price="{data}">
                    <span style="color: #e53e3e;">{{formatPrice(data.push_price)}}</span>
                </template>

                <template #push_state="{data}">
                    <c-state dict="PUSH_STATE" :value="data.push_state"></c-state>
                </template>

                <template #push_type="{data}">
                    <c-state dict="SYNC_TYPE" :value="data.push_type"></c-state>
                </template>
            </view-list>
            <erp-push-detail ref="detail"></erp-push-detail>
        </module>
    </page>
</template>

<script>
import ErpPushDetail from './components/push_detail.vue';

export default {
    name: 'erp_push_list',
    components: {ErpPushDetail},
    methods: {
        searchMerchant(keyword, resolve) {
            this.request({url: '/sys_saas/options', data: {keyword}, success: resolve});
        },
        /*********搜索推送渠道**********/
        searchChannel(keyword, resolve) {
            this.request({
                url: '/sale/product/channel/options',
                data: {keyword},
                success: data => {
                    resolve((data || []).map(item => {
                        return {
                            name: item.channel_name,
                            value: item.channel_id
                        };
                    }));
                }
            });
        },
        formatPrice(price) {
            if (price === null || price === undefined || price === '') return '-';
            return '¥' + parseFloat(price).toFixed(2);
        },
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.model_name) parts.push(data.model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        }
    }
};
</script>

<style scoped>
.m-saas-info {line-height: 20px; font-size: 13px; color: #333;}
.m-saas-info p {margin: 0;}
.m-saas-info-name {color: #999; font-size: 12px;}
</style>
